import { Mirror } from "../Cartridge"

export abstract class Mapper {
    constructor(
        protected programBanks: number,
        protected characterBanks: number,
    ) {
        this.reset()
    }

    abstract cpuMapRead(address: number): [mappedAddress?: number, data?: number]
    abstract cpuMapWrite(address: number, data: number): number | undefined
    abstract ppuMapRead(address: number): number | undefined
    abstract ppuMapWrite(address: number): number | undefined
    abstract reset(): number | void

    mirror() {
        return Mirror.HARDWARE
    }
}
